<template>
  <div class="card">
    <div class="card-content">
      <!-- Icon section -->
      <div class="icon-container">
        <img :src="iconSrc" alt="Practical Skills Icon" class="icon" />
      </div>

      <!-- Text section -->
      <div class="text-container">
        <h4 class="title">{{ title }}</h4>
        <p class="description">{{ description }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SkillsCard",
  props: {
    iconSrc: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    }
  }
};
</script>

<style scoped>
.card {
  background-color: #d8b384; /* Beige-like background */
  border-radius: 0.625rem; /* 10px */
  padding: 2rem 1.5rem; /* 16px */
  display: inline-block;
  margin: auto;
  border: 1px solid #cb7f2c;
  max-width: 25rem; /* 400px */
  box-shadow: 0 0 0.625rem rgba(0, 0, 0, 0.1); /* 10px */
}

.card:hover {
  transform: scale(1.1);
  transition: all .5s;
  cursor: pointer;
}

.card-content {
  display: flex;
  align-items: center;
}

.icon-container {
  width: 3.125rem; /* 50px */
  display: flex;
  justify-content: center;
  align-items: center;
}

.icon {
  width: 4.5rem; /* 50px */
}

.text-container {
  margin-left: 1rem; /* 16px */
}

.title {
  font-size: 1.05rem; /* 18px */
  color: black;
  font-weight: bold;
  margin: 0;
  font-family: 'GothicB';
  text-align: left;
  padding-bottom: 0.4rem;
}

.description {
  font-family: 'Gothic';
  font-size: 0.83rem; /* 14px */
  color: black;
  margin: 0;
  text-align: left;
}

@media screen and (max-width: 480px) {
  .title {
    font-size: 1.5rem;
  }
  .description {
    font-size: 1.3rem;
  }
  .card-content {
    gap: 0.9rem;
  }
  .icon {
    width: 5.5rem;
  }
  .card {
    max-width: initial;
  }
}
</style>
